<template>
  <v-flex class="relationship">
    <v-layout row wrap>
      <v-flex xs12>
        <h2 class="primary--text pb-2">Relationships</h2>
        <p>Add or Remove relationships between the current case template and other templates.</p>
      </v-flex>
      <v-flex xs12>
        <Relationship
          v-for="(relation, index) in relationships"
          :key="relation.id"
          :caseTypeName="getCaseType(relation.fromId).name"
          :relation="relation"
          :position="index"
          v-on:delete-relationship="deleteRelationship"
        ></Relationship>
        <v-btn
          v-show="!addingNewRelationship"
          v-on:click="addingNewRelationship = true"
          class="ml-0"
          color="secondary"
        >Add a Relationship</v-btn>
        <form v-show="addingNewRelationship">
          <v-layout wrap row class="px-4 pt-4 pb-0" style="background:rgb(240, 240, 240);">
            <v-flex
              xs12
              sm6
              :class="{'pr-0': $vuetify.breakpoint.mdAndDown, 'pr-2': $vuetify.breakpoint.mdAndUp}"
            >
              <span class="caption" style="opacity:0.54">Step One</span>
              <h3 class="pb-2">Select template to link to</h3>
              <v-autocomplete
                v-model="newRelation.templateSelected"
                :items="caseTemplates"
                item-text="name"
                item-value="id"
                label="Template"
                class="white-box-field"
                no-data-text="No templates found"
                box
                append-icon="keyboard_arrow_down"
              ></v-autocomplete>
            </v-flex>
          </v-layout>
          <div v-if="newRelation.templateSelected">
            <v-layout
              wrap
              class="px-4 pt-4 pb-0"
              style="border-top:1px solid white;:1px; background:rgb(240, 240, 240);"
            >
              <v-flex xs12>
                <span class="caption" style="opacity:0.54">Step Two</span>
                <h3 class="pb-2">Choose fields to link between the two case templates</h3>
              </v-flex>
              <v-flex
                xs12
                sm6
                :class="{'pr-0 chip-multiple-select': $vuetify.breakpoint.mdAndDown, 'pr-2 chip-multiple-select': $vuetify.breakpoint.mdAndUp}"
              >
                <v-autocomplete
                  box
                  chips
                  :label="'Configure field'"
                  :items="currentTemplateFields"
                  v-model="newRelation.selectedFieldsCurrentTemplate"
                  item-text="name"
                  item-value="value"
                  class="white-box-field"
                  append-icon="keyboard_arrow_down"
                >
                  <template slot="selection" slot-scope="data">
                    <v-chip close class="white--text" color="secondary">{{ data.item.name }}</v-chip>
                  </template>
                  <template slot="item" slot-scope="data">
                    <template v-if="typeof data.item !== 'object'">
                      <v-list-tile-content v-text="data.item"></v-list-tile-content>
                    </template>
                    <template v-else>
                      <v-list-tile-content class="dropdown-selected-tick">
                        <v-list-tile-title v-html="data.item.name"></v-list-tile-title>
                      </v-list-tile-content>
                    </template>
                  </template>
                </v-autocomplete>
              </v-flex>
              <v-flex
                xs12
                sm6
                :class="{'chip-multiple-select pl-0': $vuetify.breakpoint.mdAndDown, 'chip-multiple-select pl-2': $vuetify.breakpoint.mdAndUp}"
              >
                <v-autocomplete
                  box
                  chips
                  :label="'Configure field'"
                  :items="getFields(newRelation.templateSelected)"
                  v-model="newRelation.selectedFieldsLinkedTemplate"
                  item-text="name"
                  item-value="value"
                  class="white-box-field"
                  append-icon="keyboard_arrow_down"
                >
                  <template slot="selection" slot-scope="data">
                    <v-chip close class="white--text" color="secondary">{{ data.item.name }}</v-chip>
                  </template>
                  <template slot="item" slot-scope="data">
                    <template v-if="typeof data.item !== 'object'">
                      <v-list-tile-content v-text="data.item"></v-list-tile-content>
                    </template>
                    <template v-else>
                      <v-list-tile-content class="dropdown-selected-tick">
                        <v-list-tile-title v-html="data.item.name"></v-list-tile-title>
                      </v-list-tile-content>
                    </template>
                  </template>
                </v-autocomplete>
              </v-flex>
            </v-layout>

            <div
              v-if="newRelation.selectedFieldsCurrentTemplate !== null && newRelation.selectedFieldsLinkedTemplate !== null"
            >
              <v-layout
                wrap
                class="px-4 pt-4 pb-0"
                style="border-top:1px solid white;; background:rgb(240, 240, 240);"
              >
                <v-flex xs12 class="chip-multiple-select">
                  <span class="caption" style="opacity:0.54">Step Three</span>
                  <h3 class="pb-2">Pick your display fields when linked</h3>
                  <v-autocomplete
                    box
                    chips
                    label="Display fields"
                    :items="getFields(newRelation.templateSelected)"
                    v-model="newRelation.selectedFieldsDisplayed"
                    item-text="name"
                    item-value="value"
                    class="white-box-field"
                    multiple
                    append-icon="keyboard_arrow_down"
                  >
                    <template v-slot:selection="data">
                      <v-chip
                        close
                        :selected="data.selected"
                        class="white--text"
                        @input="removeNewRelationDisplayField(data.index)"
                        color="secondary"
                      >{{ data.item.name }}</v-chip>
                    </template>
                  </v-autocomplete>
                </v-flex>
              </v-layout>
            </div>
          </div>
          <v-layout
            wrap
            row
            class="pa-4"
            style="border-top:1px solid white;; background:rgb(240, 240, 240);"
          >
            <v-flex xs12 class="pt-1">
              <v-btn
                class="ml-0 mt-0 mr-2"
                :disabled="!newRelation.selectedFieldsDisplayed.length > 0"
                color="success"
                v-on:click="addNewRelationship()"
              >Confirm Relationship</v-btn>
              <v-btn color="error" class="mt-0 ml-0" v-on:click="clearNewRelationship()">Cancel</v-btn>
            </v-flex>
          </v-layout>
        </form>
      </v-flex>
    </v-layout>
  </v-flex>
</template>

<script>
import { mapState } from "vuex"
import Relationship from "./Relationship.vue"

export default {
  name: "case-config-relationships",
  components: { Relationship },
  data() {
    return {
      addingNewRelationship: false,
      newRelation: {
        templateSelected: "",
        selectedFieldsCurrentTemplate: null,
        selectedFieldsLinkedTemplate: null,
        selectedFieldsDisplayed: []
      }
    }
  },
  props: { caseType: { type: Object, required: true } },
  computed: {
    ...mapState({
      caseTypes: state => state.caseTypes.all
    }),
    relationships() {
      return this.caseType.relationships
    },
    newRelationLinkSection() {
      return (this.newRelation && this.newRelation.templateSelected !== "")
    },
    newRelationDisplaySection() {
      return (this.newRelation && this.newRelation.selectedFieldsCurrentTemplate !== null && this.newRelation.selectedFieldsLinkedTemplate !== null)
    },
    caseTemplates() {
      if (this.caseTypes) {
        const cts = this.caseTypes.filter(
          caseType => caseType.id !== this.caseType.id
        )
        cts.sort(function(a, b) {
          if (a.name < b.name) {
            return -1
          }
          if (a.name > b.name) {
            return 1
          }
          return 0
        })
        return cts
      }
      return []
    },
    currentTemplateFields() {
      return this.getFields(this.caseType.id)
    },
    selections() {
      if (this.relationships.length > 0) {
        return this.prepareSelections(this.relationships)
      } else {
        return []
      }
    }
  },
  methods: {
    async addNewRelationship() {
      let existingRelations = []
      if (this.relationships) {
        existingRelations = this.relationships
      }
      const response = await this.$store.dispatch("createDirectRelationship", {
        fromId: this.caseType.id,
        toId: this.newRelation.templateSelected,
        toFieldsetKey: this.newRelation.selectedFieldsLinkedTemplate.fieldset,
        fromFieldsetKey: this.newRelation.selectedFieldsCurrentTemplate
          .fieldset,
        fromRelationKey: this.newRelation.selectedFieldsCurrentTemplate.field,
        toRelationKey: this.newRelation.selectedFieldsLinkedTemplate.field,
        position: existingRelations.length
      })

      if (!response.error) {
        const newFields = []
        const self = this
        for (
          let index = 0;
          index < this.newRelation.selectedFieldsDisplayed.length;
          index++
        ) {
          const result = await self.$store.dispatch(
            "createDirectRelationshipDisplayField",
            {
              relationId: response.id,
              fieldName: this.newRelation.selectedFieldsDisplayed[index].field
            }
          )
          newFields.push({
            id: result.id,
            fieldName: this.newRelation.selectedFieldsDisplayed[index].field,
            __typename: "RelatedField"
          })
        }
        const newRelationship = {
          id: response.id,
          fromId: this.caseType.id,
          toId: this.newRelation.templateSelected,
          fromFieldsetKey: this.newRelation.selectedFieldsCurrentTemplate.fieldset,
          fromRelationKey: this.newRelation.selectedFieldsCurrentTemplate.field,
          toFieldsetKey: this.newRelation.selectedFieldsLinkedTemplate.fieldset,
          toRelationKey: this.newRelation.selectedFieldsLinkedTemplate.field,
          fields: newFields
        }
        existingRelations.push(newRelationship)
        this.$store.dispatch("updateRelationships", existingRelations)
        this.clearNewRelationship()
      }
    },
    deleteRelationship(relation) {
      if (this.relationships) {
        const response = this.$store.dispatch(
          "deleteDirectRelationship",
          relation.id
        )
        if (!response.error) {
          const index = this.relationships.indexOf(relation)
          if (index >= 0) {
            this.relationships.splice(index, 1)
          }
        }
      } else {
        console.error(
          "Error, cannot delete non-existant relationship!",
          relation
        )
      }
    },
    clearNewRelationship() {
      this.addingNewRelationship = false
      this.newRelation = {
        templateSelected: "",
        selectedFieldsCurrentTemplate: null,
        selectedFieldsLinkedTemplate: null,
        selectedFieldsDisplayed: []
      }
    },
    async removeDisplayField(relation, item) {
      const response = await this.$store.dispatch(
        "deleteDirectRelationshipDisplayField",
        { relationId: relation.id, id: item.id }
      )
      if (!response.error) {
        const index = this.selections[relation].selectedFieldsDisplayed.indexOf(
          item.value
        )
        if (index >= 0) { this.selections[relation].selectedFieldsDisplayed.splice(index, 1) }
      }
    },
    removeNewRelationDisplayField(index) {
      if (index >= 0) this.newRelation.selectedFieldsDisplayed.splice(index, 1)
    },
    getCaseType(id) {
      let caseType
      if (this.caseTypes) {
        caseType = this.caseTypes.find(function(element) {
          return element.id === id
        })
      }
      if (!caseType) {
        caseType = {
          id: id,
          name: "MISSING"
        }
      }
      return caseType
    },
    getFields(id) {
      const caseType = this.getCaseType(id)
      const fields = []
      fields.push({ header: "case_details" })
      fields.push({
        name: "title",
        value: { field: "title", fieldset: "case_details" }
      })
      fields.push({
        name: "created_at",
        value: { field: "created_at", fieldset: "case_details" }
      })
      fields.push({
        name: "updated_at",
        value: { field: "updated_at", fieldset: "case_details" }
      })
      fields.push({
        name: "last_exported_at",
        value: { field: "last_exported_at", fieldset: "case_details" }
      })
      fields.push({
        name: "last_exported_via_bucket_id",
        value: { field: "last_exported_via_bucket_id", fieldset: "case_details" }
      })
      fields.push({
        name: "current_state",
        value: { field: "current_state", fieldset: "case_details" }
      })
      fields.push({
        name: "owner_name",
        value: { field: "owner_name", fieldset: "case_details" }
      })
      fields.push({
        name: "sentiment_score",
        value: { field: "sentiment_score", fieldset: "case_details" }
      })
      fields.push({
        name: "sentiment_magnitude",
        value: { field: "sentiment_magnitude", fieldset: "case_details" }
      })
      fields.push({
        name: "no_unread_conversations",
        value: { field: "no_unread_conversations", fieldset: "case_details" }
      })
      fields.push({
        name: "unresolved_task_failures",
        value: { field: "unresolved_task_failures", fieldset: "case_details" }
      })
      if (caseType && caseType.currentSchema) {
        caseType.currentSchema.fieldsets.forEach(function(fieldset) {
          if (fieldset.name !== "case_details") {
            fields.push({ header: fieldset.name })
            fieldset.fields.forEach(function(field) {
              fields.push({
                name: field.name,
                value: { field: field.name, fieldset: fieldset.name }
              })
            })
          }
        })
      }
      return fields
    },
    prepareSelections(data) {
      const selections = []
      for (let i = 0; i < data.length; i++) {
        const selection = {
          templateSelected: "",
          selectedFieldsCurrentTemplate: "",
          selectedFieldsLinkedTemplate: "",
          selectedFieldsDisplayed: []
        }
        const fieldList = this.getFields(data[i].toId)
        if (data[i].toId) {
          selection.templateSelected = data[i].toId
        }
        if (data[i].fromRelationKey) {
          selection.selectedFieldsCurrentTemplate = data[i].fromRelationKey
        }
        if (data[i].toRelationKey) {
          selection.selectedFieldsLinkedTemplate = data[i].toRelationKey
        }
        if (data[i].fields) {
          data[i].fields.forEach(function(field) {
            if (field) {
              let select
              if (fieldList) {
                select = fieldList.find(function(element) {
                  return element.name === field.fieldName
                })
              }
              if (select) {
                selection.selectedFieldsDisplayed.push(select)
              }
            }
          })
        }
        selections.push(selection)
      }
      return selections
    }
  }
}
</script>

<style>
.v-menu__content .v-list__tile--active.primary--text {
  font-weight: 700;
}

.v-menu__content .theme--light.v-subheader {
  text-transform: uppercase;
  background: #f0f0f0;
}

.v-menu__content .v-list {
  padding: 0;
}
</style>
